// Survey messages
export const requiredQuestion = "Obavezno odgovoriti";
export const invalidSurveyForm = "Molimo da odgovorite na obavezna pitanja.";

// Hospital Info messages
export const requiredField = "Obavezno unijeti";
export const invalidHospitalForm = "Molimo da unesete obavezna polja.";
export const invalidNameLength = "Molimo unesite do 80 znakova.";
export const invalidAddressLength = "Molimo unesite do 50 znakova.";
export const invalidPhoneLength = "Molimo unesite do 15 znamenki.";

// User messages
export const invalidEmail = "Neispravan email";
export const invalidLength = "Molimo unesite do 30 znakova.";

// Statistics messages
export const invalidStatisticsForm =
  "Molimo da provjerite unesene vrijednosti.";
